import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { UpsellModalComponentType } from '@app-types/eligibility/config';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, PLAY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class MixedCartJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.MIXED_CART;
    protected readonly wordings = {
        mainTitle: 'Bbox + forfait mobile',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly tracking = {
        page: 'Eligibilite_test',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_mixte',
        marketLine: 'Mixte',
        variant: {
            type_offres: 'Offres_Box',
        },
    };
    protected readonly offerCategoryCodeToShow = PlanTypeId.FAI_SIMO_ELIGIBILITE;
    protected readonly fallbackMismatchOffers = PlanTypeId.FAIM_UNLIMITED;
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: "La fibre est nécessaire pour profiter de l'offre Bbox + forfait mobile",
        alertDescription:
            'Vous pouvez renseigner vos coordonnées pour être prévenu de l’arrivée de la fibre ou retourner au panier pour finaliser la commande de votre forfait mobile.',
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_panier_mixte',
            nomClic: 'Ok',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_panier_mixte',
            nomClic: 'Eligibilite_ko_panier_mixte',
        },
        buttonLabel: 'Revenir au panier',
        alwaysShowCta: true,
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: '/panier',
    };
    protected readonly productsToUpsell = [
        {
            baseProduct: {
                rangeNg: 'must',
                commercialSeries: 'serie_client_bandyou',
                play: PLAY._3P,
                isHiddenDefault: true,
            },
            upselledProduct: { rangeNg: 'must', commercialSeries: 'serie_client_bandyou', play: PLAY._2P },
            modalComponentType: UpsellModalComponentType.BYOU,
        },
        {
            baseProduct: {
                rangeNg: 'very_fit',
                commercialSeries: 'standard',
                isHiddenDefault: true,
            },
        },
    ];
    protected readonly technologies = [TECHNOLOGY.FTTH];
}
